<template>
  <div class="Header">
    <div class="w-main Header-box">
      <router-link to="/" tag="a" class="Header-box-logo">
        <el-image :src="img.logo" fit="fill"></el-image>
      </router-link>
      <div class="Header-link">
        <router-link
          to="/"
          tag="a"
          class="Header-link-a"
          :class="{ linkACtiv: routerName === '/' }"
        >
          首页
        </router-link>
        <router-link
          to="/about"
          tag="a"
          class="Header-link-a linkMover"
          :class="{ linkACtiv: routerName === 'about' }"
        >
          关于我们
          <div class="linkBox">
            <router-link
              :to="{
                path: '/about',
                query: { pages: 'page1' }
              }"
              tag="div"
              class="linkBox-a"
            >
              学会简介
            </router-link>
            <router-link
              :to="{
                path: '/about',
                query: { pages: 'page2' }
              }"
              tag="div"
              class="linkBox-a"
            >
              学会荣誉
            </router-link>
            <router-link
              :to="{
                path: '/about',
                query: { pages: 'page3' }
              }"
              tag="div"
              class="linkBox-a"
            >
              大事记
            </router-link>
            <router-link
              :to="{
                path: '/about',
                query: { pages: 'page4' }
              }"
              tag="div"
              class="linkBox-a"
            >
              理事会成员
            </router-link>
            <router-link
              :to="{
                path: '/about',
                query: { pages: 'page5' }
              }"
              tag="div"
              class="linkBox-a"
            >
              学会章程
            </router-link>
            <router-link
              :to="{
                path: '/about',
                query: { pages: 'page6' }
              }"
              tag="div"
              class="linkBox-a"
            >
              联系我们
            </router-link>
          </div>
        </router-link>
        <router-link
          to="/new"
          tag="a"
          class="Header-link-a linkMover"
          :class="{ linkACtiv: routerName === 'new' }"
        >
          新闻中心
          <div class="linkBox">
            <router-link
              v-for="(item, index) in newData"
              :key="index"
              :to="{
                path: '/new',
                query: { id: item.id }
              }"
              tag="div"
              class="linkBox-a"
            >
              {{ item.name }}
            </router-link>
            <!-- <router-link
              :to="{
                path: '/new',
                query: { id: 'page3' }
              }"
              tag="div"
              class="linkBox-a"
            >
              论坛沙龙
            </router-link> -->
          </div>
        </router-link>
        <router-link
          to="/periodical"
          tag="a"
          class="Header-link-a linkMover"
          :class="{ linkACtiv: routerName === 'periodical' }"
        >
          期刊出版
          <div class="linkBox">
            <router-link
              :to="{
                path: '/periodical',
                query: { pages: 'page2' }
              }"
              tag="div"
              class="linkBox-a"
            >
              《航海》阅读
            </router-link>
            <router-link
              :to="{
                path: '/periodical',
                query: { pages: 'page1' }
              }"
              tag="div"
              class="linkBox-a"
            >
              专业书籍
            </router-link>
          </div>
        </router-link>
        <router-link
          to="/learning"
          tag="a"
          class="Header-link-a linkMover"
          :class="{ linkACtiv: routerName === 'learning' }"
        >
          学术交流
          <div class="linkBox">
            <router-link
              :to="{
                path: '/learning',
                query: { pages: 'page1' }
              }"
              tag="div"
              class="linkBox-a"
            >
              专业委员会
            </router-link>
            <router-link
              :to="{
                path: '/learning',
                query: { pages: 'page2' }
              }"
              tag="div"
              class="linkBox-a"
            >
              专家风采
            </router-link>
            <router-link
              :to="{
                path: '/learning',
                query: { pages: 'page4' }
              }"
              tag="div"
              class="linkBox-a"
            >
              科普园地
            </router-link>
          </div>
        </router-link>
        <router-link
          to="/consulting"
          tag="a"
          class="Header-link-a linkMover"
          :class="{ linkACtiv: routerName === 'consulting' }"
        >
          业务咨询
          <div class="linkBox">
            <router-link
              :to="{
                path: '/consulting',
                query: { pages: 'page1' }
              }"
              tag="div"
              class="linkBox-a"
            >
              技术咨询
            </router-link>
            <router-link
              :to="{
                path: '/consulting',
                query: { pages: 'page2' }
              }"
              tag="div"
              class="linkBox-a"
            >
              高级职称申报
            </router-link>
            <router-link
              :to="{
                path: '/consulting',
                query: { pages: 'page3' }
              }"
              tag="div"
              class="linkBox-a"
            >
              磁罗经技术服务
            </router-link>
          </div>
        </router-link>
        <router-link
          to="/vip"
          tag="a"
          class="Header-link-a"
          :class="{ linkACtiv: routerName === 'vip' }"
        >
          会员中心
        </router-link>
        <!--  -->
        <a
          :href="`http://hhai.cbpt.cnki.net/`"
          target="_blank"
          class="Header-link-a"
        >
          在线投稿
        </a>
        <!-- <router-link
          to="/leaving"
          tag="a"
          class="Header-link-a"
          :class="{ linkACtiv: routerName === 'leaving' }"
        >
          技术咨询
        </router-link> -->
        <!-- <router-link
          to="/branch"
          tag="a"
          class="Header-link-a"
          :class="{ linkACtiv: routerName === 'branch' }"
        >
          磁罗经技术服务
        </router-link> -->
      </div>
    </div>
  </div>
</template>

<script>
import logo from "@/assets/img/home/logo_b.png";
import { getCategoryList } from "@/api/api.js";

export default {
  name: "pcHomeHeard",
  data() {
    return {
      img: {
        logo
      },
      routerName: "/",
      newData: []
      // learning: {
      //   name: "",
      //   id: ""
      // }
    };
  },
  watch: {
    $route(newValue) {
      this.routerNameFiltter(newValue.path);
    }
  },
  mounted() {
    this.routerNameFiltter(this.$route.path);
    this.getCategoryList();
  },
  methods: {
    routerNameFiltter(val) {
      const routerArr = val.split("/");
      this.routerName = routerArr[1] ? routerArr[1] : "/";
    },
    getCategoryList() {
      getCategoryList().then(res => {
        if (res.code === 0) {
          // 导航分类
          this.newData = res.data;
          // // this.ImgData = res.data;
          // this.content = res.data.content ? res.data.content : "暂无数据";
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    }
    // getExchangeConsultCategory() {
    //   getExchangeConsultCategory(this.pags).then(res => {
    //     if (res.code === 0) {
    //       this.learning = res.data[0];
    //     } else {
    //       this.$message({
    //         message: res.msg,
    //         type: "error"
    //       });
    //     }
    //   });
    // }
  }
};
</script>

<style lang="less">
.Header {
  width: 100%;
  height: 100px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 30px 0px rgba(0, 0, 0, 0.24);
  &-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    &-logo {
      width: 240px;
      height: 56px;
    }
  }
  &-link {
    .linkACtiv {
      color: #165194;
      border-bottom: 2px solid #165194;
    }
    &-a {
      display: inline-block;
      margin: 0 25px;
      height: 30px;
      line-height: 30px;
      font-size: 16px;
      font-weight: bold;
      color: rgba(52, 52, 52, 1);
    }
    .linkMover {
      position: relative;
      .linkBox {
        display: none;
        position: absolute;
        top: 32px;
        padding-top: 34px;
        width: 180px;
        background: rgba(255, 255, 255, 1);
        z-index: 99;
        .linkBox-a {
          width: 100%;
          height: 40px;
          line-height: 40px;
          padding: 0 30px;
          font-size: 14px;
          font-weight: bold;
          color: rgba(52, 52, 52, 1);
          box-sizing: border-box;
        }
        .linkBox-a:hover {
          color: rgba(22, 81, 148, 1);
        }
      }
    }
    .linkMover:hover {
      .linkBox {
        display: block;
      }
      .linkBox:hover {
        display: block;
      }
    }
    // &-a.router-link-exact-active {
    //   color: #165194;
    //   border-bottom: 2px solid #165194;
    // }
    &-a:last-child {
      margin: 0 0 0 25px;
    }
  }
}
</style>
